module.exports = __webpack_public_path__ + "static/media/Mom-jeans.4655801d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/denim/Mom-jeans.jpg
// module id = 140
// module chunks = 0